import constantFactory from "@gaoding/constant-factory";

export const { EVENT, EVENT_LIST, EVENT_MAP, EVENT_ITEM_MAP } = constantFactory(
  "EVENT",
  [
    {
      key: "CHANGE_SEARCH_INPUT_VISIBLE",
      label: "设置搜索栏显示状态",
      value: "changeSearchInputVisible",
    },
    {
      key: "RELOAD_LAST_BOARDS",
      label: "重新加载最新画板",
      value: "reloadLastBoards",
    },
    {
      key: "DELETE_PIN",
      label: "删除采集",
      value: "deletePin",
    },
    {
      key: "UPDATE_PIN",
      label: "更新采集",
      value: "updatePin",
    },
    {
      key: "FOLLOW_PIN_LIST_RESET",
      label: "重置关注页瀑布流",
      value: "followPinListReset",
    },
    {
      key: "DISCOVERY_PIN_LIST_RESET",
      label: "重置发现页瀑布流",
      value: "discovertyPinListReset",
    },
    {
      key: "SEARCH_BAR_FOCUS",
      label: "搜索栏获取焦点",
      value: "searchBarFocus",
    },
    {
      key: "PAGE_SETTING_CHANGE",
      label: "偏好设置调整",
      value: "pageSettingChange",
    },
    {
      key: "TOPIC_FILTER_DRAWER_OPEN",
      label: "主题页筛选器抽屉",
      value: "topicFilterDrawerOpen",
    },
    {
      key: "PIN_MATERIAL_TIME_N",
      label: "素材采集次数超过N次",
      value: "pin_detail_download_bubble",
    },
    {
      key: "MODAL_PREVIEW_CLOSE",
      label: "关闭查看大图弹窗",
      value: "modal_preview_close",
    },
    {
      key: "BOARDLIST_DATA_UPDATE",
      label: "画板列表数据更新",
      value: "boardlist_data_update",
    },
    {
      key: "FOLLOWING_USER_GROUP_LIST_UPDATE",
      label: "关注用户分组列表更新",
      value: "following_user_group_list_update",
    },
    {
      key: "FOLLOWING_BOARD_GROUP_LIST_UPDATE",
      label: "关注画板分组列表更新",
      value: "following_board_group_list_update",
    },
    {
      key: "CARD_OPERATE",
      label: "采集卡片操作",
      value: "card_operate",
    },
    {
      key: "MATERIAL_DOWNLOAD",
      label: "素材下载",
      value: "material_download",
    },
    {
      key: "IMAGE_LOAD_ERROR",
      label: "图片加载失败",
      value: "image_load_error",
    },
    {
      key: "CHANGE_PIN_BOARD",
      label: "调整采集的所属画板",
      value: "change_ping_board",
    },
  ]
);
